import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommUnitChangeConfirmation extends Layout {
    textboxUnitNumber: Textbox;
    textboxUnitType: Textbox;
}
